import {Capacitor, registerPlugin} from "@capacitor/core";

interface AppleSignInPlugin {
  signIn(options: {nonce: string}): Promise<{authorizationCode: string; displayName?: string}>;
}

const native = registerPlugin<AppleSignInPlugin>("SproutAppleSignIn");

export function supportsAppleSignIn(): boolean {
  return Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios" && Capacitor.isPluginAvailable("SproutAppleSignIn");
}

export async function requestAppleCredential(nonce: string): Promise<{authorizationCode: string; displayName?: string}> {
  if (!supportsAppleSignIn()) throw new Error("APPLE_SIGN_IN_UNAVAILABLE");
  return native.signIn({nonce});
}

export function isAppleSignInCancelled(error: unknown): boolean {
  return typeof error === "object" && error !== null && "code" in error && error.code === "APPLE_SIGN_IN_CANCELLED";
}
